// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"45":"4cd8f9d12c12e231d875","124":"780f26619197dfb95e26","276":"123da7fa0686053c4d3f","508":"7826b83c873f2831bb88"}[chunkId] + ".js";
};